import styled from 'styled-components';
import { makeStyles } from '@mui/styles';

export const Root = styled.div`
  position: relative;
  display: flex;
  flex: 1 1 auto;
  max-width: 100vw;
  margin: 0 20px;
`;

export const TopPanel = styled.div`
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;

  & > *:not(first-child) {
    margin-left: 5px;
  }
  width: 100%;
  height: 35px;
`;

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  marginLeftButton: {
    marginLeft: theme.spacing(1),
    float: 'right'
  },
  toRight: {
    float: 'right'
  },
  toLeft: {
    float: 'left',
    lineHeight: '36px'
  },
  yearSelector: {
    float: 'right',
    marginLeft: '10px'
  }
}));

export const ButtonContainer = styled.div`
`;
